"use strict";

import _ from "lodash";

import { Accounting } from "../../../gateway/Accounting/Accounting";
import { AssistantHttpGateway } from "../../../gateway/AssistantHttpGateway";
import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../presentation/services/Events/Events";
import "./help-dialog.scss";
import "./help-dialog-dark.scss";

class HelpDialogCtrl {
    AssistantHttpGateway = new AssistantHttpGateway();
    loading = false;
    constructor($rootScope, $mdDialog, locals, $stateParams) {
        this.$rootScope = $rootScope;
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.$stateParams = $stateParams;
        this.user = new UserDataAdapter().user();
        this.Events = new Events();
        this.Accounting = new Accounting();
        this.userGateway = new User();
        this.accountingId = this.$stateParams.accountingId;
    }
    $onInit() {
        this.features = [
            "Balanço",
            "Cenários",
            "Conta Azul",
            "Customização",
            "DRE",
            "Dashboards",
            "Demonstrações",
            "Domínio",
            "Fortes",
            "Carteira Consultiva",
            "Gestão de usuários",
            "Grupo Empresarial",
            "Importação de dados",
            "Auditoria",
            "NPS",
            "Nibo",
            "Nucont Score",
            "Omie",
            "Outras",
            "Prospect",
            "Dash",
            "Showtime"
        ];
    }
    cancel() {
        this.$mdDialog.cancel();
        this._onCleanForm();
    }
    async onFeedback() {
        this.loading = true;
        if (!this.feedback) {
            this.$rootScope.$broadcast(
                "SET_NANDA_NOTIFICATION",
                "ERROR_REPORTED_SUCCESSFULLY"
            );
        }
        if (!this.feedback) return;
        this.Events.send("Feedback.Enviar");
        await this.AssistantHttpGateway.sendFeedback({
            userId: this.user._id,
            accountingId: this.accountingId,
            feature: this.feedback.feature,
            description: this.feedback.details
        });
        this._onCleanForm();
        this.loading = false;
        this.$mdDialog.hide();
    }
    teplateFeedback(accounting, user, feedback) {
        accounting.createdAtClient();
        return `
             <table
        style="
          font-family: Open Sans, sans-serif;
          width: 100%;
          color: #2e5573;
          font-size: 16px;
        "
      >
        <tbody>
          <tr>
            <td valign="top">
              <table
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  height: 4px;
                  width: 100%;
                  background-color: #00cbd2;
                  margin-bottom: 24px;
                "
              >
                <tbody>
                  <tr></tr>
                </tbody>
              </table>
              <h1
                style="
                  text-align: center;
                  font-size: 24px;
                  margin: 0;
                  font-family: Open Sans, sans-serif;
                "
              >
                  Novo Feedback 
              </h1>
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                style="
                  font-size: 0;
                  height: 30px;
                  width: 100%;
                  min-width: 100%;
                  line-height: 0;
                "
              >
                <tbody>
                  <tr>
                    <td height="30">
                      <span
                        style="
                          color: transparent;
                          background: none;
                          text-overflow: ellipsis;
                          opacity: 0;
                          width: 100%;
                          min-width: 100%;
                          height: 1;
                          padding: 0;
                          font-size: 0;
                        "
                      >
                        &nbsp;</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <p style="color: #2e5573; font-family: Open Sans, sans-serif">
                O usuário <strong> ${
                    _.get(user, "profile.nickname") ||
                    _.get(user, "profile.name")
                } </strong> enviou um feedback
              </p>
            </td>
          </tr>
          <tr>
            <td>
             <p><strong>Contabilidade:</strong> ${accounting.props.name} </p>
              <p><strong>Código da Nucont:</strong> ${_.get(
                  accounting,
                  "props.superLogica._id"
              )}</p>
              <p><strong>Cliente desde:</strong> ${
                  accounting.props.createdAtFormated
              } </p>
                <table
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  height: 2px;
                  width: 100%;
                  background-color: #e8e7e6;
                  margin-bottom: 24px;
                "
              >
                <tbody>
                  <tr></tr>
                </tbody>
              </table>
              <p><strong>Usuário</strong></p>
              <p>
                <strong>Email:</strong>
               ${user.username}
              </p>
             <p>
              <strong>Função:</strong>
               ${this.userGateway._transformRole(user.roles[0])}
              </p>
                <table
                cellpadding="0"
                cellspacing="0"
                border="0"
                style="
                  height: 2px;
                  width: 100%;
                  background-color: #e8e7e6;
                  margin-bottom: 24px;
                "
              >
                <tbody>
                  <tr></tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td>
             <p><strong>Feedback:</strong></p>
               <ul>
                <li> <p><strong>Feature:</strong> ${feedback.feature}</p></li>
                <li> <p><strong>Descrição:</strong> ${feedback.details}</p></li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
        `;
    }
    _onCleanForm() {
        this.document = { data: {} };
        if (this.form) {
            this.form.$setPristine();
            this.form.$setUntouched();
        }
    }
}

angular
    .module("nucont.shared")
    .controller("HelpDialogCtrl", [
        "$rootScope",
        "$mdDialog",
        "locals",
        "$stateParams",
        HelpDialogCtrl
    ]);
